(function (window, $) {
    'use strict';

    let desktopChecker = false;
    let mobileChecker = false;

    function lazyLoaderInit() {
        new LazyLoad({
            elements_selector: "[data-src]",
            to_webp: true,
            load_delay: 400
        });

        new LazyLoad({
            elements_selector: ".jumbotron .lazy"
        });
    }

    function pageLoadedChecker() {
        let everythingLoaded = setInterval(function () {
            if (/loaded|complete/.test(document.readyState)) {
                clearInterval(everythingLoaded);
                $('html').addClass('page-loaded');
            }
        }, 10);
    }

    function headerDepthFeedback() {
        if ($(document).scrollTop() > 0 && $('.main-navigation').not('.main-navigation--shadow')) {
            $('.main-navigation').addClass('main-navigation--shadow')
        } else {
            $('.main-navigation').removeClass('main-navigation--shadow')
        }
    }

    function getMobileOperatingSystem() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            mobileChecker = true;

            $('html').addClass('mobile');
        }
    }

    function revealItemsOnScroll() {
        var winWidth = $(window).width();
        var winHeight = $(window).height();
        var tollerance = winHeight / 10;

        if (winWidth < 768) {
            tollerance = 0;
        }

        function reveal() {

            var count = 1;

            $('.reveal.not-revealed').each(function () {
                var $this = $(this);

                if ($(document).scrollTop() + winHeight - tollerance > $this.offset().top && !$this.attr('revealed')) {
                    $this.attr('revealed', 1);

                    setTimeout(function () {
                        $this.removeClass('not-revealed');
                    }, count * 80);
                    count++;

                    if ($this.hasClass('pills')) {
                        progressiveCounter();
                    }
                }
            });
        }

        setTimeout(function () {
            reveal();
        }, 150);

        $(document).scroll(function () {
            reveal();
        });

        $(window).resize(function () {
            reveal();
        });
    }

    function sliderNewsInit() {
        $('.slider.slider--news').lightSlider({
            item: 4,
            loop: false,
            slideMove: 2,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            speed: 600,
            slideMargin: 15,
            pager: true,
            controls: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        item: 3,
                        slideMove: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        item: 2,
                        slideMove: 1
                    }
                }
            ]
        });
    }

    function sliderCurriculumnInit() {
        $('.slider.slider--curriculum').lightSlider({
            item: 3,
            auto: true,
            loop: true,
            slideMove: 1,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            speed: 600,
            slideMargin: 60,
            pager: true,
            controls: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        item: 2,
                    }
                }
            ]
        });
    }

    function toggleReviewPanel() {
        $('.reviews li').each(function () {
            var that = $(this);
            var text = $(this).data('text')

            $('button', that).click(function () {
                $('.review-overlay-text').html(text);
                $('.review-overlay').fadeIn();
            })
        });

        $('.close-panel').click(function () {
            $('.review-overlay').fadeOut();
        })
    }

    $(document).ready(function () {
        lazyLoaderInit();

        pageLoadedChecker();

        getMobileOperatingSystem();

        headerDepthFeedback();

        revealItemsOnScroll();

        sliderNewsInit();

        sliderCurriculumnInit();

        toggleReviewPanel()
    });

    $(window).scroll(function () {
        headerDepthFeedback();
    });
})(window, jQuery);
